import { render, staticRenderFns } from "./lookStudent.vue?vue&type=template&id=51adc0da&scoped=true&"
import script from "./lookStudent.vue?vue&type=script&lang=js&"
export * from "./lookStudent.vue?vue&type=script&lang=js&"
import style0 from "./lookStudent.vue?vue&type=style&index=0&id=51adc0da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51adc0da",
  null
  
)

export default component.exports